<template>
  <div>
    <!-- Preloader Starts -->
    <div class="preloader">
      <div class="spinner"></div>
    </div>
    <!-- Preloader End -->

    <!-- Header Area Starts -->
    <header class="header-area single-page">

      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <div class="logo-area">
                <router-link to="/"><img src="./assets/logo5.png" alt="logo"></router-link>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="custom-navbar">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="main-menu main-menu-light">
                <ul>
                  <li class="active">
                    <router-link class="underline" to="/">首页</router-link>
                  </li>
                  <li>
                    <router-link to="/about" class="underline">关于我们</router-link>
                  </li>
                  <li>
                    <router-link to="/products" class="underline">产品展示</router-link>
                  </li>
                  <li>
                    <a to="/news" class="underline" style="cursor:pointer" @click="route()">新闻中心</a>
                  </li>
                  <li>
                    <router-link to="/joinus" class="underline">加入我们</router-link>
                  </li>
                  <li>
                    <router-link to="/contact" class="underline">联系我们</router-link>
                  </li>
                  <li class="menu-btn d-inline-flex">
                    <div class="input-group flex-nowrap">
                      <input type="search" class="form-control" placeholder="查询产品" aria-label="搜索" v-model="text">
                      <div class="input-group-append ">
                        <button class="btn btn-outline-secondary" type="button">
                          <i class="fas fa-search" @click="search()"></i>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
    <!-- Header Area End -->
    <div class="qqkefu">
      <ul>
        <li class="top anchor" @click="returntop()">TOP<span></span></li>
        <li class="qq_cza" @click="toQQ()"><a href="javascript:;" class="underline"><b class="a"></b>咨询</a></li>
        <li class="qq_cza" id="zx"><a href="javascript:;" class="underline"><b class="b"></b>在线咨询</a></li>
        <li class="qq_czb">
          <b class="c"></b>
          <div class="erweima">
            <p><img src="static/assets/images/qrcode.png">二维码</p>
            <!--                  <i class="arrow3"></i>-->
          </div>
        </li>
      </ul>
    </div>
    <router-view></router-view>

    <!-- Footer Area Starts -->
    <footer class="footer-area section-padding4 section-padding5">
      <div class="footer-widget">
        <div class="container">
          <div class="row">
            <div class="col-xl-2 col-lg-3">
              <div class="single-widget-home mb-5 mb-lg-0">
                <h3 class="mb-4">产品导航</h3>
                <ul>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">西安天隆</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">上海智城</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">上海屹谱</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">北京中仪宇盛</a></li>
                  <!--                <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">大连松洋</a></li>-->
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-lg-3">
              <div class="single-widget-home mb-5 mb-lg-0">
                <ul style="padding-top: 55px">
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">上海仪硕</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">上海美瑞克</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">宁波新芝</a></li>
                  <li class="mb-2"><a href="javascript:void(0);" class="underline" @click="toProducts()">北京大龙</a></li>
                </ul>
              </div>
            </div>
            <div class="col-xl-5 offset-xl-1 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0">
                <h3 class="mb-4">联系方式</h3>
                <p class="mb-3">电话：010-67047381，010-61807868</p>
                <p class="mb-3">电子邮箱：zehaotian@139.com</p>
                <p class="mb-3">公司地址：北京市门头沟区熙旺中心A座1026</p>

              </div>
            </div>
            <div style="width: 100px; height: 100px">

              <img src="/static/assets/images/qrcode.png" alt="feed" style="height: 100px; width: 100px">
            </div>
            <span style="padding-top: 20px">Copyright © 北京泽浩天科技发展有限公司　备案号：京ICP备2025103103号-1</span>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer Area End -->

  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {
      pageLists: [
        {
          title: '首页',
          link: '/'
        },
        {
          title: '公司简介',
          link: 'introduction'
        },
        {
          title: '产品展示',
          link: 'news'
        },
      ],

      navLists: [],
      text: this.$route.query.text,
      total: 0,
    }
  },
  watch: {
    '$route'(to, from) {
      console.log("random:" + to.query.s)
      console.log("parentId:" + to.params.parentId)
      console.log("from.path:" + from.path)
      to.query.s = Math.random // 补充新的随机数
      if (to.path === from.path && to.hash === '') {// 判断是重复访问当前页面时候，同时不是访问页内的id

        this.$router.go(0) // 重新访问当前页面
      }
    }
  },
  methods: {
    route() {
      this.$_storage.removeLocalStore("index");
      this.$router.push({name: 'news'});
    },
    search() {
      if (this.text == '' || this.text == undefined || this.text == null) {
        this.$alert("未查询到产品信息");
        return;
      }
      this.getSearch();

    },
    returntop() {
      window.scrollTo(0, 0)
    },
    toQQ() {
      window.open("https://wpa.qq.com/msgrd?v=3&uin=1466551568&site=qq&menu=yes&jumpflag=1");
    },
    getSearch() {
      var vm = this;
      vm.$_axios({
        method: 'post',
        url: '/mapis/search/searchDocs',
        data: {
          text: vm.text,
          pageNo: vm.pageNo,
          pageSize: vm.pageSize
        },
        needLogin: false,
      }).then((response) => {
        if (response.status === 200) {
          const responseData = response.data.data;
          vm.total = responseData.total;
          if (vm.total == 0) {
            this.$alert("未查询到产品信息");
            return;
          }
          this.$router.push({name: 'search', query: {text: this.text, s: Math.random()}});
        }
      });
    },
    toProducts() {
      const vm = this;
      vm.$router.push({name: 'products'});
    },
  },
  created() {
  },
  mounted() {
    let vm = this;
    // vm.getMenu();
  },


};
</script>





// WEBPACK FOOTER //
// App.vue?43701f3b